import React, { useState } from 'react';

import Modal from './Modal/Modal';

const CompetitionBanner = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const handleJoinNowClick = e => {
    e.preventDefault();
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleGoToCompetition = () => {
    window.location.href = '/tagme/co-future-2025';
  };

  const handleTitleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleTitleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <>
      <section className='py-16 bg-gray-50 border-b border-black'>
        <div className='max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center'>
          <div
            className='relative inline-block cursor-default mb-8'
            onMouseEnter={handleTitleMouseEnter}
            onMouseLeave={handleTitleMouseLeave}
          >
            <h2 className='text-3xl md:text-4xl lg:text-5xl font-black text-black'>
              Student Competitions 2025
            </h2>
            {/* 動態下滑線 */}
            <div
              className={`absolute bottom-0 left-0 h-0.5 bg-black transition-all duration-500 ease-out ${
                isHovered ? 'w-full' : 'w-0'
              }`}
              style={{
                transitionProperty: 'width',
                transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',
              }}
            />
          </div>

          <div className='text-center'>
            <button
              onClick={handleJoinNowClick}
              className='bg-transparent text-black px-8 py-3 rounded-md text-lg font-medium border border-black hover:bg-tag-blue hover:text-white hover:border-transparent transition-colors duration-200'
            >
              Join Now
            </button>
          </div>
        </div>
      </section>

      <Modal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onGoToCompetition={handleGoToCompetition}
      />
    </>
  );
};

export default CompetitionBanner;
